module.exports = __webpack_public_path__ + "static/media/10-4.33e8aa19.mp3";